module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1045-af19b4925398ae33de5aaed05eef9cde.png";